import { DEFAULT_TENANT_THEME } from './defaultTenantTheme';

const HEX_COLOR_REGEX = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

const isObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

const pickColor = (value, fallback) => {
  if (typeof value !== 'string') return fallback;
  return HEX_COLOR_REGEX.test(value.trim()) ? value.trim() : fallback;
};

const pickNumber = (value, fallback) => {
  if (typeof value !== 'number' || Number.isNaN(value) || value < 0) return fallback;
  return value;
};

const pickString = (value, fallback) => (typeof value === 'string' && value.trim() ? value.trim() : fallback);

export const validateTenantTheme = (rawTheme) => {
  const fallback = DEFAULT_TENANT_THEME;
  if (!isObject(rawTheme)) return fallback;

  const branding = isObject(rawTheme.branding) ? rawTheme.branding : {};
  const tokens = isObject(rawTheme.tokens) ? rawTheme.tokens : {};
  const tokenColor = isObject(tokens.color) ? tokens.color : {};
  const tokenRadius = isObject(tokens.radius) ? tokens.radius : {};
  const tokenSpacing = isObject(tokens.spacing) ? tokens.spacing : {};
  const tokenFont = isObject(tokens.font) ? tokens.font : {};

  return {
    version: pickString(rawTheme.version, fallback.version),
    tenantId: pickString(rawTheme.tenantId, fallback.tenantId),
    branding: {
      name: pickString(branding.name, fallback.branding.name),
      logoUrl: pickString(branding.logoUrl, fallback.branding.logoUrl),
      faviconUrl: pickString(branding.faviconUrl, fallback.branding.faviconUrl)
    },
    tokens: {
      color: {
        primary: pickColor(tokenColor.primary, fallback.tokens.color.primary),
        secondary: pickColor(tokenColor.secondary, fallback.tokens.color.secondary),
        surface: pickColor(tokenColor.surface, fallback.tokens.color.surface),
        text: pickColor(tokenColor.text, fallback.tokens.color.text),
        success: pickColor(tokenColor.success, fallback.tokens.color.success),
        error: pickColor(tokenColor.error, fallback.tokens.color.error)
      },
      radius: {
        sm: pickNumber(tokenRadius.sm, fallback.tokens.radius.sm),
        md: pickNumber(tokenRadius.md, fallback.tokens.radius.md),
        lg: pickNumber(tokenRadius.lg, fallback.tokens.radius.lg)
      },
      spacing: {
        xs: pickNumber(tokenSpacing.xs, fallback.tokens.spacing.xs),
        sm: pickNumber(tokenSpacing.sm, fallback.tokens.spacing.sm),
        md: pickNumber(tokenSpacing.md, fallback.tokens.spacing.md),
        lg: pickNumber(tokenSpacing.lg, fallback.tokens.spacing.lg)
      },
      font: {
        heading: pickString(tokenFont.heading, fallback.tokens.font.heading),
        body: pickString(tokenFont.body, fallback.tokens.font.body)
      }
    }
  };
};
